export default __webpack_public_path__ + "static/187-5604fd9290715c772b580ac1f51c3382.jpg";